import React, { useContext } from 'react';
import ls from './Summary.less';
import { DeclaredComponent } from './DynamicComponent';
import { ConfigContext } from './PortalApp';

export function Summary({ hideNavLabels, onSubmitEmail }) {
  const { summary } = useContext(ConfigContext);
  return (
    <div className={ls.root}>
      <div className={ls.content}>
        <DeclaredComponent declaration={summary} onSubmitEmail={onSubmitEmail} />
      </div>
    </div>
  );
}
